import React from 'react'
import DealersList from './DealersList'



class DealerPage extends React.Component {


  constructor(){
    super();

    this.state={
          clickedFeaturedDealer: false
    }

    this.findDealer = this.findDealer.bind(this)
  }




  findDealer(dealer){
    //console.log("dealer",dealer);
    this.setState({clickedFeaturedDealer:dealer})
  }



  render () {

        // Don't render until there is data


      let featuredDealers = []
      if(this.props.dealersData){
        featuredDealers = this.props.dealersData.data.filter((item,i)=>{
            return(item.acf.feature_dealer_on_dealer_page)
        })
      }

      let content = {}

      return(

          <div className="dealer-app">

            {
              (featuredDealers.length)?
            <div className="featured-dealers content-row">

                {
                  featuredDealers.map((featuredDealer,i)=>{

                    //console.log("Featured Dealer",featuredDealer);

                    let bgStyle = {}
                    if(featuredDealer.acf.feature_image){
                      bgStyle.backgroundImage = 'url('+featuredDealer.acf.feature_image+')'
                    }
                    return(<div key={'fd'+i} className="featured-dealer" onClick={()=>this.findDealer(featuredDealer)}>
                                <div className={"inner bg"+((i % 3))} style={bgStyle}>
                                  <div className="sub-title">Featured Dealer</div>
                                  <h4 className="title" dangerouslySetInnerHTML={{__html:featuredDealer.title.rendered}} />
                                  <div className="location"  dangerouslySetInnerHTML={{__html:featuredDealer.acf.Contact.city}} />
                                </div>
                            </div>)

                  })
                }

            </div>
            : null
            }


            <DealersList clickedFeaturedDealer={this.state.clickedFeaturedDealer} />


          </div>
        )
  }
}



export default DealerPage;
